import { ISearchRegionsCitiesResponseSchema } from '../../repositories/monolith-python/entities/schemas/SearchRegionsCitiesResponseSchema';
import { IRegion } from '../../types/requestForm';

export const prepareRegionSuggests = (response: ISearchRegionsCitiesResponseSchema): IRegion[] => {
  if (!response.items) {
    return [];
  }

  return response.items.map(region => ({
    id: region.id,
    label: region.displayName,
  }));
};
